import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={529.724}
      height={346.876}
      viewBox="0 0 529.724 346.876"
      {...props}
    >
      <defs>
        <linearGradient
          id="prefix__f"
          x1={-3.197}
          y1={0.145}
          x2={-3.758}
          y2={0.873}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#f7b686" stopOpacity={0.149} />
          <stop offset={1} stopColor="#f2b18f" stopOpacity={0.298} />
        </linearGradient>
        <linearGradient
          id="prefix__g"
          x1={-0.117}
          y1={2.312}
          x2={0.431}
          y2={0.946}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#e1dee6" />
          <stop offset={1} stopColor="#ebebeb" />
        </linearGradient>
        <linearGradient
          id="prefix__h"
          x1={1.001}
          y1={-5.077}
          x2={0.814}
          y2={-3.048}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#e1dee6" />
          <stop offset={1} stopColor="#18206b" />
        </linearGradient>
        <linearGradient
          id="prefix__i"
          x1={0.176}
          y1={1.024}
          x2={0.503}
          y2={0.349}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#fb8145" />
          <stop offset={1} stopColor="#fee543" />
        </linearGradient>
        <linearGradient
          id="prefix__a"
          x1={0.464}
          y1={0.304}
          x2={0.798}
          y2={2.218}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#e1473d" />
          <stop offset={1} stopColor="#e9605a" />
        </linearGradient>
        <linearGradient
          id="prefix__j"
          x1={0.465}
          y1={0.307}
          x2={0.799}
          y2={2.221}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__d"
          x1={0.883}
          y1={-0.025}
          x2={0.347}
          y2={0.708}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#09005d" />
          <stop offset={1} stopColor="#1a0f91" />
        </linearGradient>
        <linearGradient
          id="prefix__b"
          x1={0.405}
          y1={0.78}
          x2={-0.227}
          y2={1.865}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#4042e2" />
          <stop offset={1} stopColor="#4f52ff" />
        </linearGradient>
        <linearGradient
          id="prefix__k"
          x1={0.638}
          y1={-2.494}
          x2={0.576}
          y2={-1.171}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__c"
          x1={0.721}
          y1={0.213}
          x2={0.27}
          y2={0.9}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#ff928e" />
          <stop offset={1} stopColor="#feb3b1" />
        </linearGradient>
        <linearGradient
          id="prefix__e"
          x1={0.293}
          y1={-0.229}
          x2={0.941}
          y2={1.514}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#fe7062" />
          <stop offset={1} stopColor="#ff928e" />
        </linearGradient>
        <linearGradient
          id="prefix__l"
          x1={1.002}
          y1={-0.401}
          x2={0.571}
          y2={0.489}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__m"
          x1={0.919}
          y1={-0.234}
          x2={-1.113}
          y2={3.878}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__n"
          x1={0.355}
          y1={-0.695}
          x2={0.52}
          y2={0.621}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__o"
          x1={0.39}
          y1={-0.467}
          x2={0.567}
          y2={0.954}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__p"
          x1={-0.133}
          y1={-2.9}
          x2={0.651}
          y2={1.263}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__q"
          x1={0.858}
          y1={1.126}
          x2={0.373}
          y2={0.286}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__r"
          x1={0.861}
          y1={-5.109}
          x2={0.85}
          y2={-4.928}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__s"
          x1={-0.177}
          y1={-6.604}
          x2={0.195}
          y2={-2.699}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__t"
          x1={0.274}
          y1={-7.138}
          x2={0.395}
          y2={-3.055}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__u"
          x1={0.361}
          y1={-7.211}
          x2={0.429}
          y2={-3.482}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__v"
          x1={0.247}
          y1={-0.355}
          x2={0.783}
          y2={1.542}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__w"
          x1={-60.412}
          y1={0.5}
          x2={-59.414}
          y2={0.5}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__x"
          x1={0.937}
          y1={0.697}
          x2={0.007}
          y2={0.175}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__y"
          x1={0.879}
          y1={-2.018}
          x2={0.626}
          y2={-0.299}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__z"
          x1={0.466}
          y1={2.02}
          x2={0.549}
          y2={-1.942}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__A"
          x1={-66.199}
          y1={0.497}
          x2={-65.198}
          y2={0.497}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__B"
          x1={-10.609}
          y1={1.035}
          x2={-10.57}
          y2={0.189}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__C"
          x1={1.257}
          y1={-1.163}
          x2={0.868}
          y2={-0.275}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__D"
          x1={-16.488}
          y1={0.5}
          x2={-15.488}
          y2={0.5}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__E"
          x1={-8.101}
          y1={0.175}
          x2={-9.108}
          y2={0.862}
          xlinkHref="#prefix__e"
        />
        <linearGradient
          id="prefix__F"
          x1={-28.24}
          y1={0.5}
          x2={-27.24}
          y2={0.5}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__G"
          x1={-15.763}
          y1={-0.027}
          x2={-17.548}
          y2={0.826}
          xlinkHref="#prefix__e"
        />
        <linearGradient
          id="prefix__H"
          x1={1.809}
          y1={-2.713}
          x2={1.118}
          y2={-1.022}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__I"
          x1={0.712}
          y1={-3.378}
          x2={0.646}
          y2={-2.065}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__J"
          x1={-28.292}
          y1={-21.118}
          x2={-29.911}
          y2={-19.766}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__K"
          x1={-15.834}
          y1={-12.69}
          x2={-14.786}
          y2={-12.69}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__L"
          x1={-79.562}
          y1={-58.038}
          x2={-76.309}
          y2={-60.426}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__M"
          x1={67.599}
          y1={51.486}
          x2={66.861}
          y2={53.923}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__N"
          x1={0.142}
          y1={1.208}
          x2={0.715}
          y2={0.111}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__O"
          y1={0.5}
          x2={1}
          y2={0.5}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#ababab" />
          <stop offset={1} stopColor="#d6d6d6" />
        </linearGradient>
        <linearGradient
          id="prefix__P"
          x1={0.311}
          y1={0.528}
          x2={-0.481}
          y2={1.539}
          xlinkHref="#prefix__e"
        />
        <linearGradient
          id="prefix__Q"
          x1={0.153}
          y1={1.133}
          x2={1.117}
          y2={-1.146}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__R"
          x1={-0.264}
          y1={1.647}
          x2={1.246}
          y2={-0.283}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__S"
          x1={1.119}
          y1={-0.598}
          x2={0.029}
          y2={0.869}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__T"
          x1={0.986}
          y1={0.153}
          x2={-1.225}
          y2={2.844}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__U"
          x1={0}
          y1={0.5}
          x2={1}
          y2={0.5}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__V"
          x1={1.439}
          y1={-0.93}
          x2={0.268}
          y2={0.668}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__W"
          x1={-26.421}
          y1={-6.233}
          x2={-26.436}
          y2={-7.549}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__X"
          x1={0.334}
          y1={0.259}
          x2={-0.5}
          y2={-1.678}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__Y"
          x1={-112.087}
          y1={-20.511}
          x2={-112.149}
          y2={-24.727}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__Z"
          x1={0.605}
          y1={0.828}
          x2={0.154}
          y2={-0.614}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__aa"
          x1={0.991}
          y1={-0.014}
          x2={0.193}
          y2={0.822}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#929292" />
          <stop offset={1} stopColor="#d6d6d6" />
        </linearGradient>
        <linearGradient
          id="prefix__ab"
          x1={0.234}
          y1={0.254}
          x2={0.956}
          y2={1.485}
          xlinkHref="#prefix__e"
        />
        <linearGradient
          id="prefix__ac"
          x1={0.061}
          y1={-0.206}
          x2={1.122}
          y2={2.239}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__ad"
          x1={80.103}
          y1={15.708}
          x2={80.628}
          y2={14.411}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__ae"
          x1={62.108}
          y1={0.154}
          x2={62.837}
          y2={1.105}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__af"
          x1={323.322}
          y1={49.625}
          x2={325.471}
          y2={45.391}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__ag"
          x1={0.442}
          y1={0.511}
          x2={2.359}
          y2={2.041}
          xlinkHref="#prefix__e"
        />
        <linearGradient
          id="prefix__ah"
          x1={-0.929}
          y1={-4.101}
          x2={-0.327}
          y2={-2.156}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__ai"
          x1={1.004}
          y1={-1.553}
          x2={0.832}
          y2={-0.785}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__aj"
          x1={1.391}
          y1={-4.21}
          x2={1.03}
          y2={-2.119}
          xlinkHref="#prefix__c"
        />
        <linearGradient
          id="prefix__ak"
          x1={1.201}
          y1={-1.825}
          x2={0.068}
          y2={2.268}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__al"
          x1={0.992}
          y1={-1.487}
          x2={0.426}
          y2={0.797}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#53d8ff" />
          <stop offset={1} stopColor="#3840f7" />
        </linearGradient>
        <linearGradient
          id="prefix__am"
          x1={1}
          y1={1.086}
          x2={0.433}
          y2={0.422}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__an"
          x1={0.69}
          y1={0.129}
          x2={0.39}
          y2={1.265}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__ao"
          x1={0.059}
          y1={0.813}
          x2={0.72}
          y2={0.586}
          xlinkHref="#prefix__b"
        />
      </defs>
      <g data-name="Layer 2">
        <path
          data-name="Path 8732"
          d="M520.613 161.78c9.693 9.366 23.613 12.733 36.746 9.7 12.453-2.877 27.235-2.033 42.329 8.357 29.21 20.124 30.521 55.947 17.415 78.109a49.612 49.612 0 00-5.528 38.085c3.019 11.279.508 23.923-21.293 29.736-44.012 11.719-285.633.15-316.5-5.083s-146.024-34.1-72.973-72.652c0 0-126.632-136.689-46.495-210.406C226.856-29.107 302.5 8.409 337.136 32.629A74.213 74.213 0 00381.7 46c40.527-1.1 115.5 7.515 112.471 86.921a23.415 23.415 0 0016.52 23.3 24.824 24.824 0 019.922 5.559z"
          transform="translate(-127.735 -.002)"
          fill="url(#prefix__f)"
        />
        <path
          data-name="Path 8733"
          d="M489.756 235.854c6.931-1.652 19.893 16.706 33.637 10.405l4.506-14.563s-18.868 2.669-26.056-1.779-2.872-7.808 2.247-7.256 18.093 7.8 23.5 4.483c0 0 4.27-2.666-.206-7.429s-1.182-15.732 2.336-19.293c0 0-2.925.269-9.823-2.242s-13.664-5.533-16.411.508-3.167 15.026-7.249 15.115-6.738-16.439 5.162-22.137c0 0-10.675-4.829-14.1-3.558s-6.766 7.668-4 17.305 1.139 14.881-1.921 14.947-6.883-29.08 3.149-33.111c0 0-21.819-.46-24.254.859s-1.659 14.1 1.779 21.56 1.017 15.318-1.588 17.14-1.388-8.618-3.324-13.272-1.271-25.38-1.271-25.38-1.462 2.541-8.847 3.482-19 6.809-17.679 11.272 11.737 24.312 12.614 31.3.1 12.794-2.681 9.757-4.043-12.047-6.862-18.238-12.024-21.2-9.455-25.136c0 0-18.535 7.495-18.937 26.264 0 0 5.513 8.387 14.065 12.413s11.968 6.1 11.633 9.363-6.219.44-11.483-2.2-17.623-8.568-18.64-12.916c0 0 1.047 28.285 20.18 30.877 17.941 2.432 20.015.447 20.2.193-.633 1-19.5 31.452 19.8 39.778 0 0-8.433-4.407-8.153-10.773s-5.5-16.065-.989-16.459 3.441 22.732 12.426 26.452 22.676-2.033 25.649-12.326a18.338 18.338 0 01-14.949-6.969c-6.054-7.716-12.128-19.766-4.687-17.615s19.422 24.981 25.944 25.545 17.4-19.72 17.4-19.72-3.426-.046-14.154-4.379-22.033-11.47-19.2-12.995 9.889 3.652 16.365 8.044 16.474 6.209 18.978 2.892 7.592-15.295 7.592-15.295-14.832-2.813-21.669-3.434-17.505-9.839-10.574-11.479zm-35.409 27.134c-7.259-5.973.671-6.4 6.1-5.541 4.1.646 1.164 11.5-6.1 5.53zm13.92-11.183c-4.9-3.84-4.443-7.03-.989-6.905 7.938.272 5.881 10.73.989 6.89zm13.307-13.526c-2.8-1.911-3.352-3.365.163-4.9s2.623 6.8-.163 4.885z"
          fill="#a0d468"
        />
        <path
          data-name="Path 8734"
          d="M58.18 147.498c-4.885-7.3 10.766-30.16-2.414-43.336l-18.764 1.057s11.183 20.658 9.127 30.87-7.79 6.674-9.348.521 1.253-24.274-4.913-29.1c0 0-4.91-3.789-8.494 3.429S5.702 119.058.08 116.522c0 0 1.566 3.266 1.627 12.316S1.18 147 9.331 147.584s18.724-2.8 20.586 1.886-16.113 14.843-27.8 3.53c0 0-1 14.4 1.934 17.824s11.76 4.542 21.7-2.793 16.706-7.7 18.1-4.2-30.638 20.426-39.6 10.575c0 0 8.832 25.415 11.4 27.657s17-4.135 24.145-11.307 17.267-7.736 20.485-5.523-9.366 5.3-13.9 9.541-28.78 12.357-28.78 12.357 3.558.6 7.82 8.73 16.012 19.031 20.612 15.59 23.059-24 30.753-28.013 14.741-5.6 12.426-1.09-12.192 9.847-18.132 15.762-19.339 22.993-24.988 21.715c0 0 16.617 18.2 38.479 10.608 0 0 7.33-9.973 8.3-21.583s1.9-16.444 5.828-17.458 3.181 6.995 2.381 14.213-2.3 24.035-6.888 27.08c0 0 32.234-13.351 27.019-36.57-4.892-21.776-8.074-23.321-8.451-23.428 1.428.3 44.711 9.025 37.467-39.953 0 0-1.474 11.638-8.951 14.047s-16.2 13.257-18.591 8.209 24.795-13.724 25.236-25.713-12.072-25.337-25.258-24.35a22.612 22.612 0 01-1.634 20.269c-6.316 10.314-17.633 22.5-18.342 12.975s20.528-33.167 18.38-40.944-30.244-11.64-30.244-11.64 1.416 3.98 1.017 18.236-3.795 30.384-6.776 27.761-.023-12.995 2.27-22.366.1-21.7-4.806-23.169-20.942-2.211-20.942-2.211 3.113 18.347 5.337 26.513-3.859 24.446-8.743 17.147zm46.553 29.268c-3.784 10.951-7.688 1.972-9.015-4.661-1.006-5.035 12.802-6.29 9.017 4.661zm-18.899-11.289c-2.338 7.3-6.217 8.151-7.556 4.107-3.075-9.289 9.892-11.407 7.556-4.107zm-21.349-9.569c-1.017 4.041-2.453 5.317-5.736 1.914s6.755-5.955 5.744-1.914z"
          fill="#98ce5e"
        />
        <path
          data-name="Path 8737"
          d="M982.7 1110.6c-.092-1.14-1.259-2.139-3.233-2.918 2.139-1.183 3.334-2.445 3.233-3.695-.306-3.762-12.224-5.874-26.615-4.713s-25.818 5.152-25.515 8.915c.092 1.143 1.259 2.139 3.233 2.922-2.139 1.183-3.331 2.445-3.233 3.695.092 1.14 1.259 2.139 3.233 2.921-2.139 1.183-3.331 2.445-3.233 3.692.092 1.143 1.259 2.139 3.233 2.922-2.139 1.183-3.331 2.445-3.233 3.695.135 1.663 2.543 3 6.418 3.881a33.986 33.986 0 00.1 4.065c.565 6.934 8.361 12.371 18.678 12.371s19.253-7.414 19.342-14.363a35.415 35.415 0 00-.2-4.535c4.936-1.65 7.946-3.667 7.784-5.614-.092-1.143-1.259-2.139-3.233-2.922 2.139-1.183 3.334-2.445 3.233-3.695-.092-1.14-1.259-2.139-3.233-2.921 2.15-1.19 3.341-2.458 3.241-3.703z"
          transform="translate(-729.127 -810.446)"
          fill="url(#prefix__h)"
        />
        <path
          data-name="Path 8738"
          d="M220.295 322.968a62.1 62.1 0 01-11.42-.935.345.345 0 11.131-.678 74.835 74.835 0 0019.021.611 81.879 81.879 0 0015.95-2.75.348.348 0 01.2.666 82.665 82.665 0 01-16.09 2.775c-2.686.203-5.298.311-7.792.311z"
          fill="#7d97f4"
        />
        <path
          data-name="Path 8739"
          d="M220.365 316.333a53.9 53.9 0 01-14.018-1.528.346.346 0 01.19-.666c4.988 1.421 13.022 1.861 21.49 1.18 8.374-.675 16.2-2.374 20.894-4.547a.35.35 0 01.305.63c-4.78 2.2-12.677 3.927-21.13 4.609-2.651.23-5.249.322-7.731.322z"
          fill="#7d97f4"
        />
        <path
          data-name="Path 8740"
          d="M220.295 309.736c-6 0-11.246-.611-14.779-1.779a.345.345 0 11.217-.654c4.917 1.62 13.251 2.139 22.309 1.424 8.374-.675 16.2-2.378 20.894-4.548a.345.345 0 01.305.611c-4.78 2.2-12.676 3.927-21.129 4.609a91.328 91.328 0 01-7.817.337z"
          fill="#7d97f4"
        />
        <path
          data-name="Path 8741"
          d="M220.341 303.119a59.509 59.509 0 01-12.447-1.134.346.346 0 11.15-.676c5.057 1.125 12.34 1.418 19.984.8 8.3-.669 16.072-2.35 20.781-4.5a.346.346 0 01.287.63c-4.786 2.179-12.643 3.881-21.02 4.557-2.64.216-5.247.323-7.735.323z"
          fill="#7d97f4"
        />
        <path
          data-name="Path 8742"
          d="M823.778 704.01a48.653 48.653 0 00-8.719-17.019c-8.557-10.8-22.548-32.767-24.271-62.743-2.5-43.6 36.172-65.433 71.46-62.471s70.109 29.24 66.3 69.8c-2.347 24.962-16.316 43.894-26.719 54.767a57.757 57.757 0 00-13.865 24.567c-3.123 11.271-10.553 25.316-28.208 26.172-22.861 1.108-32.35-20.177-35.978-33.073z"
          transform="translate(-631.99 -437.245)"
          fill="url(#prefix__i)"
        />
        <path
          data-name="Path 8743"
          d="M1035.716 919.342l12.349-80.307c.254-1.659 1.07-2.775 1.833-2.488s1.152 1.858.9 3.518a.292.292 0 01-.024.144l-14.073 79.57c-.107.611-.41.978-.678.844s-.396-.701-.307-1.281z"
          transform="translate(-802.128 -628.199)"
          fill="url(#prefix__a)"
        />
        <path
          data-name="Path 8744"
          d="M959.4 921.427l-12.346-80.307c-.254-1.659-1.073-2.775-1.834-2.491s-1.155 1.861-.9 3.521a.752.752 0 00.024.141l14.056 79.563c.1.611.41.975.678.844s.412-.691.322-1.271z"
          transform="translate(-738.628 -629.645)"
          fill="url(#prefix__j)"
        />
        <path
          data-name="Path 8745"
          d="M245.851 203.941a1.3 1.3 0 00-1.623-.422l-6.873 3.212-2.387-6.8a1.461 1.461 0 00-.837-.84 1.693 1.693 0 00-2.112.651v.021l-5.654 10.308-5.243-14.669v-.02a1.687 1.687 0 00-.795-.9 2.06 2.06 0 00-2.595.51l-7.91 10.883a.956.956 0 00.278 1.375 1.326 1.326 0 001.681-.183l6.94-7.781 6.265 13.963a1.1 1.1 0 00.55.541 1.311 1.311 0 001.641-.425l6.048-9.7 2.274 4.908.021.043c.015.037.037.07.055.107a1.3 1.3 0 001.62.419l8.163-3.814a.972.972 0 00.492-1.384z"
          fill="#fff"
          opacity={0.75}
        />
        <path
          data-name="Path 8746"
          d="M270.097 238.197a.993.993 0 01-.611-.2 1.015 1.015 0 01-.211-1.424 91.371 91.371 0 005.764-8.753 1.018 1.018 0 011.763 1.018 94.424 94.424 0 01-5.886 8.957 1.014 1.014 0 01-.819.402z"
          fill="#fff"
          opacity={0.54}
        />
        <path
          data-name="Path 8747"
          d="M280.254 220.765a1 1 0 01-.4-.086 1.015 1.015 0 01-.529-1.339c13.141-30.255 1.791-55.715 1.675-55.968a1.019 1.019 0 111.852-.85c.119.263 11.842 26.536-1.659 57.628a1.018 1.018 0 01-.939.615z"
          fill="#fff"
          opacity={0.54}
        />
        <path
          data-name="Path 8748"
          d="M106.444 884.565s-14.07 7.795-15.234 20.985-.1 67.938 28.114 81.413 65.556 10.37 79.853 8.9 22.218-11.183 23.99-17.875 4.631-31.606-10.42-39.648-30.819-20.345-46.6-32.336-42.83-31.557-59.703-21.439z"
          transform="translate(-68.612 -657.655)"
          fill="url(#prefix__d)"
        />
        <path
          data-name="Path 8749"
          d="M540.352 1122.29s-3.8.2-4.262 8.013c0 0 8.8 7.879 20.7 9.772.895.14-1.248-6.1-1.571-6.941-1.531-4.02-6.355-6.597-14.867-10.844z"
          transform="translate(-400.64 -837.056)"
          fill="url(#prefix__b)"
        />
        <path
          data-name="Path 8750"
          d="M96.949 276.049h8.013s24.594-27.164 40.726-29.9c0 0 11.229 14.334-.6 41.115a3.905 3.905 0 01-5.591 1.845 3.218 3.218 0 01-1.271-1.525l.951-22.874s-20.978 18.347-24.625 21.888-22.196 1.386-17.603-10.549z"
          fill="#7d97f4"
        />
        <path
          data-name="Path 8751"
          d="M633.524 1289.43a30.106 30.106 0 00-16.431-7.19l-2.613 1.6a28.548 28.548 0 004.707 5.05c2.8 1.624 7.116 3.812 10.695 4.3 3.484.464 3.998-1.638 3.642-3.76z"
          transform="translate(-459.107 -956.354)"
          fill="url(#prefix__k)"
        />
        <path
          data-name="Path 8752"
          d="M154.578 296.089c-2.066.669-2.976 3.6-8.227 1.662a46.512 46.512 0 01-10.8-5.688 18.15 18.15 0 00-.1 1.194s9.284 8.829 21.179 10.71a1.184 1.184 0 001.271-1.6 29.818 29.818 0 00-3.323-6.278z"
          fill="#91b3fa"
        />
        <path
          data-name="Path 8753"
          d="M176.948 335.589a27.865 27.865 0 00-2.542-2.513c.356 2.122-.158 4.224-3.639 3.761-3.571-.478-7.891-2.679-10.687-4.3 3.5 2.991 8.837 6.163 15.569 5.978a1.779 1.779 0 001.3-2.923z"
          fill="#91b3fa"
        />
        <path
          data-name="Path 8754"
          d="M97.24 281.856l37.526.406s21.43 17.73 25.316 44.764c0 0 .646 1.987-3.228 2.328a74.3 74.3 0 01-21.4-23.423c-10.359-18.342-30.88-10.085-30.88-10.085-6.743-4.862-16.266-5.846-23.448-7.472z"
          fill="#7d97f4"
        />
        <path
          data-name="Path 8755"
          d="M369.776 990s4.038 20.246 23.832 28.254l7.04-.829 1.662 2.648-16.52.526a45.192 45.192 0 01-21.6-20.841c-.239-.484-4.356-8.995 5.586-9.758z"
          transform="translate(-271.649 -738.388)"
          fill="url(#prefix__c)"
        />
        <path
          data-name="Path 8756"
          d="M271.421 962.915s-4.6-12.487-5.591-24.62a52.769 52.769 0 015.462-4.135 1.525 1.525 0 00.592-1.97c-1.545-3.2-10.883-15.758-11.584-15.935-3.812-.948-19.4-8.364-30.379 6.659-4.715 6.448.935 26.3 22.32 46.851l4.412.844z"
          transform="translate(-171.128 -681.399)"
          fill="url(#prefix__e)"
        />
        <path
          data-name="Path 8757"
          d="M308.173 1021.55s12.764 15.112 29.08 17.32c0 0 4.216-3.843 7.353-2.47s7.437 7.432 7.437 7.432h-20.952s-19.811-.7-29.711-12.708c.798-4.209 3.182-6.724 6.793-9.574z"
          transform="translate(-225.582 -761.92)"
          fill="url(#prefix__l)"
        />
        <path
          data-name="Path 8758"
          d="M290.481 882.36l-2.8 9.315a1.017 1.017 0 00.4 1.141 10.406 10.406 0 009.681.971 1.525 1.525 0 00.976-1.3l.661-8.113z"
          transform="translate(-215.334 -658.105)"
          fill="url(#prefix__m)"
        />
        <path
          data-name="Path 8759"
          d="M308.979 833.977s-1.372 9.658-5.083 12.624-10.929.732-13.376-6.547l4.865-12.454z"
          transform="translate(-217.482 -617.263)"
          fill="url(#prefix__n)"
        />
        <path
          data-name="Path 8760"
          d="M278.852 811.847a.478.478 0 00.623-.381 12.45 12.45 0 011.144-3.858s-.353-1.271 3.2.648 8.9 4.725 12.037 3.05c3.065-1.632 6.171-9.843-1.929-8.324a.478.478 0 01-.569-.508c.1-1.349-.036-4.455-3.179-5.452-2.943-.933-4.554.4-5.218 1.2a.475.475 0 01-.745 0 5.511 5.511 0 00-6.8-2.049c-2.9 1.271-3.355 3.068-3.3 4.183a.475.475 0 01-.679.452 2.872 2.872 0 00-3.69 1.1c-1.893 2.371.813 4.43 1.624 4.969a.483.483 0 01.219.4c0 1.233.2 6.608 2.9 9.658a.48.48 0 00.8-.14l2.076-4.948a.481.481 0 01.59-.272z"
          transform="translate(-201.497 -593.448)"
          fill="url(#prefix__o)"
        />
        <path
          data-name="Path 8761"
          d="M296.256 852.056s-1.271-5.167-3.195-3.49.508 5.37 2.709 6.074z"
          transform="translate(-218.857 -632.651)"
          fill="url(#prefix__p)"
        />
        <path
          data-name="Path 8762"
          d="M496.57 1012.486l9.4-31.373a3.207 3.207 0 012.854-2.287l12.708-.869a1.8 1.8 0 011.822 2.394l-10.514 29.96a2.641 2.641 0 01-2.224 1.749l-12.507 1.39z"
          transform="translate(-371.164 -729.403)"
          fill="url(#prefix__q)"
        />
        <path
          data-name="Path 8763"
          d="M142.755 262.345c-.7 1.418-1.916 2.249-2.709 1.855s-.866-1.863-.165-3.279 1.914-2.249 2.709-1.855.866 1.857.165 3.279z"
          fill="#7d97f4"
        />
        <path
          data-name="Path 8764"
          d="M420.636 1106.7h-.061l-26.651-1.347a1.194 1.194 0 11.122-2.379l26.651 1.347a1.195 1.195 0 01-.058 2.389z"
          transform="translate(-293.693 -822.64)"
          fill="url(#prefix__r)"
        />
        <path
          data-name="Path 8765"
          d="M368.627 971.788a.282.282 0 01-.28-.285c.018-5.556-2.127-12.939-2.15-13.013a.282.282 0 11.541-.158c.023.074 2.191 7.533 2.173 13.173a.282.282 0 01-.285.282z"
          transform="translate(-273.916 -714.611)"
          fill="url(#prefix__s)"
        />
        <path
          data-name="Path 8766"
          d="M304.216 984.3a.277.277 0 01-.221-.107c-.058-.074-5.894-7.492-7.9-12.581a.282.282 0 11.526-.206c1.977 5.009 7.759 12.362 7.818 12.436a.282.282 0 01-.221.458z"
          transform="translate(-221.624 -724.384)"
          fill="url(#prefix__t)"
        />
        <path
          data-name="Path 8767"
          d="M254.957 1025.3l-.211-.089c-8.456-3.622-13.676-13.724-13.724-13.813a.284.284 0 11.508-.254c.048.1 5.083 9.846 13.236 13.47l.836-1.182a.282.282 0 01.46.328z"
          transform="translate(-180.542 -754.037)"
          fill="url(#prefix__u)"
        />
        <g data-name="Group 458" opacity={0.64} fill="#7d97f4">
          <path
            data-name="Path 8770"
            d="M81.008 106.61a1.3 1.3 0 01-1.245-.933c-.2-.681-.389-1.372-.562-2.056a1.3 1.3 0 112.521-.635c.165.651.346 1.309.536 1.957a1.3 1.3 0 01-.882 1.614 1.233 1.233 0 01-.368.053z"
          />
          <path
            data-name="Path 8771"
            d="M79.195 97.774a1.3 1.3 0 01-1.289-1.146 56.723 56.723 0 01-.351-4.364 1.301 1.301 0 112.6-.107c.056 1.388.168 2.8.333 4.16a1.3 1.3 0 01-1.136 1.446c-.053.011-.106.011-.157.011zm-.183-11.2H78.9a1.3 1.3 0 01-1.184-1.405c.122-1.451.3-2.91.536-4.341a1.301 1.301 0 012.569.419 49.5 49.5 0 00-.508 4.14 1.3 1.3 0 01-1.3 1.187zm2.079-11a1.271 1.271 0 01-.371-.056 1.3 1.3 0 01-.877-1.616c.417-1.4.892-2.8 1.416-4.143a1.301 1.301 0 112.427.938 49.066 49.066 0 00-1.35 3.947 1.3 1.3 0 01-1.245.93zm4.29-10.352a1.3 1.3 0 01-1.141-1.921 58 58 0 012.234-3.764 1.301 1.301 0 112.183 1.416 49.285 49.285 0 00-2.13 3.589 1.3 1.3 0 01-1.146.676zm6.323-9.251a1.3 1.3 0 01-.991-2.14 55.161 55.161 0 012.953-3.23 1.3 1.3 0 011.848 1.83 54.802 54.802 0 00-2.816 3.078 1.3 1.3 0 01-.994.458zm8.072-7.772a1.3 1.3 0 01-.8-2.323 51.576 51.576 0 013.558-2.562 1.3 1.3 0 111.435 2.16 53.527 53.527 0 00-3.383 2.445 1.3 1.3 0 01-.81.276zm9.475-5.968a1.3 1.3 0 01-.577-2.468 53.687 53.687 0 013.993-1.779 1.3 1.3 0 01.968 2.414 53.18 53.18 0 00-3.812 1.7 1.3 1.3 0 01-.572.129zm47.527-.427a1.271 1.271 0 01-.554-.127 52.18 52.18 0 00-3.84-1.629 1.3 1.3 0 01.923-2.432c1.36.508 2.714 1.09 4.028 1.71a1.3 1.3 0 01-.557 2.478zm-37.028-3.482a1.3 1.3 0 01-.325-2.562 56.452 56.452 0 014.277-.928 1.3 1.3 0 01.45 2.562 51.34 51.34 0 00-4.066.884 1.337 1.337 0 01-.341.043zm26.457-.231a1.382 1.382 0 01-.3-.036 53.08 53.08 0 00-4.094-.811 1.301 1.301 0 11.407-2.57c1.436.226 2.88.508 4.293.849a1.3 1.3 0 01-.3 2.567zm-15.384-1.444a1.3 1.3 0 01-.058-2.6 56.917 56.917 0 014.374-.036 1.3 1.3 0 11-.079 2.6c-1.4-.041-2.8-.03-4.173.036z"
          />
          <path
            data-name="Path 8772"
            d="M164.609 46.331a1.3 1.3 0 01-.742-.234 57.637 57.637 0 00-1.69-1.126 1.301 1.301 0 011.405-2.191c.592.381 1.189.778 1.779 1.182a1.3 1.3 0 01-.742 2.369z"
          />
        </g>
        <g data-name="Group 459" opacity={0.64} fill="#7d97f4">
          <path
            data-name="Path 8773"
            d="M187.378 82.368a1.3 1.3 0 01-1.271-1.093 52.77 52.77 0 00-.366-2 1.3 1.3 0 112.542-.508c.142.691.269 1.4.384 2.094a1.3 1.3 0 01-1.073 1.494 1.507 1.507 0 01-.216.013z"
          />
          <path
            data-name="Path 8774"
            d="M133.01 145.858c-1.128 0-2.287-.053-3.411-.132-.3-.02-.595-.043-.89-.069a1.3 1.3 0 11.216-2.592l.854.066c1.083.074 2.175.117 3.253.127a1.3 1.3 0 010 2.6zm6.819-.363a1.3 1.3 0 01-.15-2.592 54.003 54.003 0 004.067-.633 1.302 1.302 0 01.508 2.554c-1.4.275-2.831.508-4.255.663zm-17.773-.831a1.409 1.409 0 01-.272-.028c-1.4-.3-2.8-.653-4.176-1.057a1.303 1.303 0 11.734-2.5c1.306.386 2.646.724 3.98 1.017a1.3 1.3 0 01-.254 2.575zm28.541-1.548a1.3 1.3 0 01-.409-2.542 52.885 52.885 0 003.843-1.438 1.303 1.303 0 111.017 2.4 55.672 55.672 0 01-4.028 1.51 1.361 1.361 0 01-.432.071zm-39.053-1.807a1.313 1.313 0 01-.508-.109 54.822 54.822 0 01-3.876-1.878 1.3 1.3 0 111.225-2.287c1.2.643 2.448 1.243 3.693 1.779a1.3 1.3 0 01-.521 2.493zm49.1-2.694a1.3 1.3 0 01-.651-2.427 52.857 52.857 0 003.477-2.183 1.301 1.301 0 111.466 2.15c-1.177.8-2.4 1.573-3.644 2.287a1.3 1.3 0 01-.643.173zm8.954-6.428a1.3 1.3 0 01-.862-2.275 50.333 50.333 0 002.971-2.834 1.301 1.301 0 111.865 1.815c-.994 1.017-2.033 2.033-3.116 2.969a1.291 1.291 0 01-.853.325zm7.49-8.087a1.288 1.288 0 01-.783-.254 1.3 1.3 0 01-.254-1.822 53.326 53.326 0 002.346-3.37 1.3 1.3 0 112.191 1.4 54.58 54.58 0 01-2.46 3.535 1.3 1.3 0 01-1.039.508zm5.711-9.427a1.3 1.3 0 01-1.174-1.86 52.485 52.485 0 001.619-3.774 1.3 1.3 0 012.427.93 53.28 53.28 0 01-1.7 3.962 1.3 1.3 0 01-1.167.743zm3.7-10.387a1.306 1.306 0 01-1.271-1.611c.325-1.319.6-2.674.823-4.021a1.3 1.3 0 012.567.422 57.518 57.518 0 01-.862 4.219 1.306 1.306 0 01-1.248.991zm1.525-10.913h-.051a1.3 1.3 0 01-1.248-1.35c.028-.717.043-1.441.043-2.155 0-.646 0-1.3-.036-1.952a1.301 1.301 0 112.6-.1 56.082 56.082 0 01-.008 4.305 1.3 1.3 0 01-1.281 1.248z"
          />
          <path
            data-name="Path 8775"
            d="M101.919 135.852a1.286 1.286 0 01-.763-.239c-.572-.4-1.149-.829-1.716-1.271a1.3 1.3 0 111.583-2.064 45.77 45.77 0 001.634 1.2 1.3 1.3 0 01-.762 2.361z"
          />
        </g>
        <path
          data-name="Path 8776"
          d="M153.238 224.357h-4.514a1.413 1.413 0 110-2.824h4.514a1.413 1.413 0 110 2.824zm-11.851 0h-4.516a1.413 1.413 0 010-2.824h4.506a1.413 1.413 0 010 2.824zm-11.854 0h-4.516a1.413 1.413 0 010-2.824h4.516a1.413 1.413 0 010 2.824zm-11.854 0h-4.518a1.413 1.413 0 010-2.824h4.516a1.413 1.413 0 010 2.824zm-11.854 0h-4.516a1.413 1.413 0 010-2.824h4.516a1.413 1.413 0 010 2.824zm-11.854 0h-4.51a1.413 1.413 0 110-2.824h4.514a1.413 1.413 0 110 2.824z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8777"
          d="M331.041 183.715h-4.516a1.411 1.411 0 010-2.821h1.693a1.413 1.413 0 012.824 0zm-11.854 0h-4.516a1.411 1.411 0 110-2.821h4.516a1.411 1.411 0 110 2.821zm-11.854 0h-4.516a1.411 1.411 0 110-2.821h4.524a1.411 1.411 0 110 2.821zm-11.854 0h-4.516a1.411 1.411 0 010-2.821h4.516a1.411 1.411 0 110 2.821zm34.148-8.748a1.413 1.413 0 01-1.411-1.41v-4.516a1.413 1.413 0 012.824 0v4.516a1.413 1.413 0 01-1.414 1.41zm0-11.854a1.411 1.411 0 01-1.411-1.411v-4.516a1.413 1.413 0 012.824 0v4.516a1.411 1.411 0 01-1.413 1.411zm19.473-5.927h-1.693a1.411 1.411 0 010-2.821h1.693a1.411 1.411 0 010 2.821zm-9.03 0h-4.519a1.411 1.411 0 110-2.821h4.516a1.411 1.411 0 110 2.821z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8778"
          d="M341.197 216.452h-4.516a1.411 1.411 0 010-2.821h4.516a1.411 1.411 0 010 2.821zm-11.854 0h-4.514a1.411 1.411 0 010-2.821h4.514a1.411 1.411 0 010 2.821zm-11.851 0h-4.516a1.411 1.411 0 010-2.821h4.532a1.411 1.411 0 010 2.821zm-11.854 0h-4.516a1.411 1.411 0 010-2.821h4.516a1.411 1.411 0 010 2.821zm-11.854 0h-4.516a1.411 1.411 0 110-2.821h4.516a1.411 1.411 0 010 2.821z"
          fill="#bdd0fb"
        />
        <path
          data-name="Rectangle 1175"
          fill="#aeaeae"
          d="M398.126 294.998h3.922v42.408h-3.922z"
        />
        <path
          data-name="Path 8779"
          d="M417.261 338.225h-34.347v-1.942a.61.61 0 01.61-.613h33.078a.661.661 0 01.658.661z"
          fill="#aeaeae"
        />
        <rect
          data-name="Rectangle 1176"
          width={45.895}
          height={13.015}
          rx={6.508}
          transform="translate(377.862 284.898)"
          fill="#cf1e22"
        />
        <path
          data-name="Path 8780"
          d="M1588.178 1292.25s-11.2 8.072-9.254 13.5c0 0 12.25-5.286 13.724-9.452s-.254-6-.254-6z"
          transform="translate(-1209.93 -962.358)"
          fill="url(#prefix__v)"
        />
        <path
          data-name="Path 8781"
          d="M1608.021 1271.39l1.83 5.294a1.84 1.84 0 01-.714 2.16 4.83 4.83 0 01-1.525.587 2.145 2.145 0 01-2.371-1.075l-2.191-4.125z"
          transform="translate(-1228.093 -948.262)"
          fill="url(#prefix__w)"
        />
        <path
          data-name="Path 8782"
          d="M1587.9 1083.93s-23 3.985-32.867 13.1 9.048 38.189 9.048 38.189 3.1-.02 6.862-3.24c0 0-11.219-21.857-1.551-28.242a62.271 62.271 0 0123.4-8.783l-4.674-10.321z"
          transform="translate(-1190.156 -808.445)"
          fill="url(#prefix__x)"
        />
        <path
          data-name="Path 8783"
          d="M1575.349 1320.937c2.463-1.139 9.437-6.018 10.611-6.234s3.215 1.167 3.215 1.167a3.175 3.175 0 01-.036 2.448c-1.634 1.98-5.269 5.754-10.166 7.162a8.52 8.52 0 01-7.673-1.06 10.4 10.4 0 014.049-3.483z"
          transform="translate(-1204.413 -980.549)"
          fill="url(#prefix__y)"
        />
        <path
          data-name="Path 8784"
          d="M1576.96 1336.152c4.885-1.408 8.519-5.182 10.166-7.162a9.906 9.906 0 01-2.951 3.993c-4.379 3.935-12.746 5.355-14.525 5.083-1.428-.219-1.294-1.525-.351-2.971a8.487 8.487 0 007.661 1.057z"
          transform="translate(-1202.387 -991.222)"
          fill="url(#prefix__z)"
        />
        <path
          data-name="Path 8785"
          d="M1630.88 1300.057c-.028.679-1.416 3.006-2.226 4.321a2.109 2.109 0 01-1.779 1.017 5.547 5.547 0 01-1.479-.178 1.375 1.375 0 01-.922-1.708l1.586-5.408z"
          transform="translate(-1244.028 -968.183)"
          fill="url(#prefix__A)"
        />
        <path
          data-name="Path 8786"
          d="M1663.888 1056.76s5.108 13.658 0 17.814-17.282 8.829-20.015 17.1-7.343 24.35-13.523 30.046c0 0-4.344-.422-5.97-2.153 0 0 3.523-24 5.845-30.16 2.01-5.337 4.974-13.03 10.652-17.333 1.626-1.233 1.342-3.185.59-5.083l-1.373-3.451z"
          transform="translate(-1244.002 -788.181)"
          fill="url(#prefix__B)"
        />
        <path
          data-name="Path 8787"
          d="M1569.668 974.409c8.565.508 5.9-13.165 5.741-13.709l13.01 9.18s-.689 7.317-11.5 11.155a13.439 13.439 0 01-7.444.541 11.834 11.834 0 00.188-7.167z"
          transform="translate(-1203.055 -716.535)"
          fill="url(#prefix__C)"
        />
        <path
          data-name="Path 8788"
          d="M1488.756 995.543c3.192-2.221 6.806 0 6.806 0 4.267 2.8 7.426 3.978 9.755 4.117a11.833 11.833 0 01-.2 7.167c-4.781-1.016-8.2-4.488-9.686-6.265a1.545 1.545 0 00-2.137-.234c-.666.526-1.311 1.245-1.194 2 .231 1.492-1.5 1.967-1.629 1.426a22.4 22.4 0 01.592-3.749s-3.462 3.482-4.814 4.829-3.05 0-3.05 0 2.364-7.073 5.557-9.291z"
          transform="translate(-1138.703 -741.786)"
          fill="url(#prefix__D)"
        />
        <path
          data-name="Path 8789"
          d="M1620.357 875.831s-12.453-4.989-35.648 14.156c0 0-1.937 4.008.175 7.576s22.246 20.958 25.014 30.6c0 0 11.994 3.9 24.4-5.337.002-.007-1.098-26.843-13.941-46.995z"
          transform="translate(-1213.809 -652.799)"
          fill="url(#prefix__E)"
        />
        <path
          data-name="Path 8790"
          d="M1606.138 860l6.135 7.437a2.446 2.446 0 01.32 2.625c-.849 1.736-2.87 4.265-7.35 3.917a3.77 3.77 0 01-3.1-2.112L1597.86 863z"
          transform="translate(-1224.222 -641.428)"
          fill="url(#prefix__F)"
        />
        <path
          data-name="Path 8791"
          d="M1726.526 909.4c1.446-5.891-13.216-19.026-13.216-19.026l3.558-12.822s31.637 21.062 23.575 38a12.339 12.339 0 01-4.47 5.266c-2.536-6.861-6.598-10.004-9.447-11.418z"
          transform="translate(-1310.33 -654.518)"
          fill="url(#prefix__G)"
        />
        <path
          data-name="Path 8792"
          d="M1725.662 941.706a.346.346 0 00.336-.254c1.479-6.023-12.708-18.823-13.31-19.367a.346.346 0 00-.463.508c.145.13 14.487 13.061 13.1 18.685a.343.343 0 00.254.417.314.314 0 00.083.011z"
          transform="translate(-1309.456 -687.684)"
          fill="url(#prefix__H)"
        />
        <path
          data-name="Path 8793"
          d="M1635.062 1000.049s17.371 6.745 21.6 1.672a2.839 2.839 0 00.58-1.164c2.849 1.416 6.91 4.559 9.457 11.416-9.15 5.846-24.752-3.248-28.974-5.927a3.151 3.151 0 00-2.333-.427 21.507 21.507 0 01-5.957.6c-2.221-.34-5.408 7.49-9.007 5.083.007-.009 3.087-13.619 14.634-11.253z"
          transform="translate(-1241.056 -745.677)"
          fill="url(#prefix__I)"
        />
        <path
          data-name="Path 8794"
          d="M1577.915 811.7c-.061.239 1.439 16.495 1.439 16.495l9.261-1.055.869-15.618s-10.532-3.822-11.569.178z"
          transform="translate(-1209.345 -604.042)"
          fill="url(#prefix__J)"
        />
        <path
          data-name="Path 8795"
          d="M1575.97 797.961l.188 8.257a1.054 1.054 0 01-.035.31c-.16.628-.874 2.747-3 1.886-1.926-.78-3.7-1.467-5-1.22a1.156 1.156 0 00-.935 1.24 49.9 49.9 0 001.271 7.637 1.154 1.154 0 001.314.829 37.159 37.159 0 008.326-2.386 1.149 1.149 0 00.671-.971c.14-2.064.585-8.336.979-10.065.371-1.621 2.5-2.384 3.411-2.643a1.136 1.136 0 00.7-.559c.508-.973 1.334-3.263-1.525-4.554a1.154 1.154 0 01-.564-1.563 3 3 0 00-1.217-4.3 4.259 4.259 0 00-5.144.658 1.156 1.156 0 01-1.482 0 .912.912 0 00-1.037-.076 1.136 1.136 0 01-1.545-.661 3.448 3.448 0 00-3.761-2.42c-4.128.254-5.083 4.687-4.3 7.434s5.238 2.224 7.564 1.136c1.779-.826 3.812.468 4.679 1.134a1.143 1.143 0 01.442.897z"
          transform="translate(-1198.245 -587.243)"
          fill="url(#prefix__K)"
        />
        <path
          data-name="Path 8796"
          d="M1627.953 844.551s-1.151-4.844.684-5.8 4.305-.081 3.375 3.235c-1.166 4.126-4.059 2.565-4.059 2.565z"
          transform="translate(-1246.401 -625.309)"
          fill="url(#prefix__L)"
        />
        <path
          data-name="Path 8797"
          d="M1530.814 1043.5h-.084l-36.448-.041a1.632 1.632 0 110-3.261l36.446.038a1.632 1.632 0 01.081 3.261z"
          transform="translate(-1145.704 -775.826)"
          fill="url(#prefix__M)"
        />
        <path
          data-name="Path 8798"
          d="M1363.226 923h30.354a5.78 5.78 0 015.231 3.3l14.034 29.756h-37.721a3.518 3.518 0 01-3.271-2.224l-10.88-27.532a2.422 2.422 0 012.254-3.3z"
          transform="translate(-1047.416 -688.417)"
          fill="url(#prefix__N)"
        />
        <path
          data-name="Path 8799"
          d="M337.195 249.833c.656 2.033.17 4.028-1.085 4.432s-2.811-.925-3.469-2.969-.17-4.028 1.085-4.432 2.811.936 3.469 2.969z"
          fill="#7d97f4"
        />
        <path
          data-name="Path 8800"
          d="M320.727 345.844a1.536 1.536 0 01-.6-.122 1.462 1.462 0 01-.8-1.947l32.12-72.292a1.553 1.553 0 012.013-.778 1.466 1.466 0 01.8 1.949l-32.12 72.292a1.524 1.524 0 01-1.413.898z"
          fill="#7e4903"
        />
        <path
          data-name="Path 8801"
          d="M356.917 345.844a1.524 1.524 0 01-1.408-.9l-32.123-72.292a1.469 1.469 0 01.8-1.949 1.55 1.55 0 012.01.778l32.123 72.291a1.464 1.464 0 01-.8 1.947 1.548 1.548 0 01-.602.125z"
          fill="#7e4903"
        />
        <path
          data-name="Path 8802"
          d="M420.16 345.844a1.539 1.539 0 01-.6-.122 1.461 1.461 0 01-.8-1.947l32.12-72.292a1.553 1.553 0 012.013-.778 1.466 1.466 0 01.8 1.949l-32.12 72.292a1.524 1.524 0 01-1.413.898z"
          fill="#7e4903"
        />
        <path
          data-name="Path 8803"
          d="M456.347 345.844a1.524 1.524 0 01-1.408-.9l-32.126-72.288a1.469 1.469 0 01.8-1.949 1.55 1.55 0 012.01.778l32.123 72.292a1.467 1.467 0 01-.8 1.947 1.55 1.55 0 01-.599.12z"
          fill="#7e4903"
        />
        <path
          data-name="Path 8804"
          d="M460.114 269.25a1.777 1.777 0 00-.3-1.337 1.39 1.39 0 00-1.113-.587H312.557a1.624 1.624 0 00-1.4.859 2.064 2.064 0 00-.109 1.779l1.583 3.838a2.221 2.221 0 002.013 1.441h143.04a1.741 1.741 0 001.65-1.525z"
          fill="#472a04"
        />
        <path
          data-name="Path 8805"
          d="M1112.882 143.2l-4.067-2.336a3.876 3.876 0 01-1.921-3.027 41.351 41.351 0 00-1.911-9.251 3.878 3.878 0 01.564-3.545l2.814-3.749a4.636 4.636 0 00.125-5.383l-3.3-4.887a4.631 4.631 0 00-5.047-1.873l-4.544 1.215a3.886 3.886 0 01-3.5-.788 41.528 41.528 0 00-7.879-5.195 3.879 3.879 0 01-2.1-2.9l-.668-4.643a4.633 4.633 0 00-3.716-3.894l-5.8-1.111a4.635 4.635 0 00-4.895 2.244l-2.336 4.066a3.886 3.886 0 01-3.029 1.921 41.361 41.361 0 00-9.249 1.911 3.879 3.879 0 01-3.558-.564l-3.759-2.813a4.643 4.643 0 00-5.385-.125l-4.887 3.3a4.641 4.641 0 00-1.873 5.05l1.228 4.554a3.879 3.879 0 01-.785 3.5 41.353 41.353 0 00-5.195 7.879 3.873 3.873 0 01-2.9 2.1l-4.644.668a4.633 4.633 0 00-3.894 3.718l-1.113 5.8a4.638 4.638 0 002.247 4.892l4.067 2.336a3.876 3.876 0 011.919 3.03 41.534 41.534 0 001.914 9.251 3.886 3.886 0 01-.564 3.545l-2.813 3.759a4.636 4.636 0 00-.125 5.383l3.3 4.887a4.638 4.638 0 005.047 1.873l4.531-1.225a3.884 3.884 0 013.5.785 41.277 41.277 0 007.879 5.195 3.884 3.884 0 012.1 2.9l.666 4.641a4.643 4.643 0 003.718 3.9l5.8 1.111a4.636 4.636 0 004.9-2.244l2.336-4.066a3.878 3.878 0 013.03-1.919 41.5 41.5 0 009.249-1.911 3.879 3.879 0 013.558.562l3.759 2.813a4.636 4.636 0 005.383.127l4.89-3.3a4.644 4.644 0 001.873-5.05l-1.225-4.532a3.871 3.871 0 01.785-3.5 41.416 41.416 0 005.195-7.879 3.873 3.873 0 012.9-2.1l4.643-.668a4.636 4.636 0 003.914-3.744l1.113-5.8a4.641 4.641 0 00-2.265-4.894zm-50.531 32.618a34.377 34.377 0 1137.274-31.213 34.377 34.377 0 01-37.274 31.217z"
          transform="translate(-789.912 -68.433)"
          fill="url(#prefix__O)"
        />
        <path
          data-name="Path 8806"
          d="M269.821 123.816a5.454 5.454 0 01-1.029-.1l-5.8-1.111a5.487 5.487 0 01-4.4-4.605l-.669-4.654a3.034 3.034 0 00-1.65-2.267 42.543 42.543 0 01-8.049-5.3 3.05 3.05 0 00-2.74-.618l-4.531 1.225a5.49 5.49 0 01-5.97-2.216l-3.3-4.887a5.487 5.487 0 01.147-6.367l2.813-3.759a3.05 3.05 0 00.437-2.773 42.446 42.446 0 01-1.949-9.439 3.049 3.049 0 00-1.5-2.371l-4.066-2.336a5.485 5.485 0 01-2.656-5.787l1.111-5.8a5.49 5.49 0 014.608-4.4l4.641-.666a3.05 3.05 0 002.269-1.649 42.373 42.373 0 015.3-8.052 3.049 3.049 0 00.62-2.737l-1.238-4.521a5.482 5.482 0 012.214-5.97l4.887-3.3a5.487 5.487 0 016.354.145l3.76 2.815a3.049 3.049 0 002.775.437 42.267 42.267 0 019.439-1.952 3.05 3.05 0 002.369-1.5l2.336-4.066a5.492 5.492 0 015.787-2.656l5.8 1.113a5.485 5.485 0 014.4 4.593l.668 4.643a3.05 3.05 0 001.647 2.267 42.228 42.228 0 018.052 5.3 3.05 3.05 0 002.74.618l4.531-1.225a5.487 5.487 0 015.97 2.216l3.3 4.887a5.492 5.492 0 01-.147 6.367l-2.813 3.759a3.034 3.034 0 00-.437 2.773 42.389 42.389 0 011.949 9.439 3.035 3.035 0 001.5 2.369l4.067 2.336a5.492 5.492 0 012.656 5.79l-1.111 5.8a5.49 5.49 0 01-4.608 4.4l-4.641.666a3.05 3.05 0 00-2.27 1.649 42.129 42.129 0 01-5.284 8.049 3.05 3.05 0 00-.618 2.74l1.225 4.532a5.482 5.482 0 01-2.214 5.97l-4.89 3.3a5.485 5.485 0 01-6.354-.147l-3.756-2.813a3.049 3.049 0 00-2.775-.437 42.351 42.351 0 01-9.439 1.952 3.034 3.034 0 00-2.369 1.5l-2.336 4.066a5.487 5.487 0 01-4.763 2.765zm-23.563-20.442a4.753 4.753 0 013.05 1.116 40.7 40.7 0 007.729 5.083 4.729 4.729 0 012.559 3.538l.668 4.643a3.8 3.8 0 003.05 3.185l5.8 1.111a3.792 3.792 0 004-1.835l2.336-4.066a4.738 4.738 0 013.688-2.343 40.51 40.51 0 009.061-1.873 4.742 4.742 0 014.321.691l3.759 2.814a3.792 3.792 0 004.4.1l4.88-3.312a3.8 3.8 0 001.525-4.127l-1.225-4.532a4.74 4.74 0 01.953-4.267 40.65 40.65 0 005.083-7.729 4.724 4.724 0 013.54-2.555l4.641-.668a3.79 3.79 0 003.185-3.05l1.113-5.8a3.8 3.8 0 00-1.838-4l-4.067-2.336a4.722 4.722 0 01-2.341-3.685 40.807 40.807 0 00-1.873-9.063 4.741 4.741 0 01.689-4.321l2.816-3.736a3.789 3.789 0 00.1-4.4l-3.3-4.887a3.794 3.794 0 00-4.127-1.525l-4.532 1.225a4.732 4.732 0 01-4.27-.953 40.6 40.6 0 00-7.726-5.083 4.741 4.741 0 01-2.562-3.538l-.666-4.643a3.794 3.794 0 00-3.05-3.185l-5.8-1.111a3.789 3.789 0 00-4 1.835l-2.336 4.066a4.74 4.74 0 01-3.688 2.343 40.533 40.533 0 00-9.061 1.873 4.735 4.735 0 01-4.321-.691l-3.759-2.813a3.792 3.792 0 00-4.4-.1l-4.88 3.289a3.792 3.792 0 00-1.525 4.127l1.225 4.532a4.743 4.743 0 01-.953 4.267 40.5 40.5 0 00-5.083 7.726 4.73 4.73 0 01-3.538 2.562l-4.656.676a3.794 3.794 0 00-3.182 3.05l-1.113 5.8a3.8 3.8 0 001.838 4l4.066 2.336a4.73 4.73 0 012.341 3.685 40.843 40.843 0 001.873 9.063 4.735 4.735 0 01-.689 4.321l-2.813 3.759a3.792 3.792 0 00-.1 4.4l3.3 4.887a3.787 3.787 0 004.128 1.525l4.531-1.225a4.705 4.705 0 011.227-.171zm29.228 4.992q-1.555 0-3.131-.137a35.233 35.233 0 113.141.137zm-2.966-1.825a33.523 33.523 0 10-30.445-36.344 33.542 33.542 0 0030.445 36.349z"
        />
        <path
          data-name="Path 8807"
          d="M1154.941 183.461c-.844.363 4.176 32.786-1.271 54.089 0 0 10.024 5.116 21.095 2.963 0 0 18.757-28.7 19.27-32.156.582-3.914-2.425-23.979-2.425-23.979s-15.882-9.901-36.669-.917z"
          transform="translate(-892.925 -134.024)"
          fill="url(#prefix__P)"
        />
        <path
          data-name="Path 8808"
          d="M1222.458 197.121c9.7.33 10.476-7.986 9.912-13.531a40.92 40.92 0 00-22.02-3.645c-.189 4.732.457 16.782 12.108 17.176z"
          transform="translate(-935.181 -134.03)"
          fill="url(#prefix__Q)"
        />
        <path
          data-name="Path 8809"
          d="M1245.591 123.57s-4.829 10.186-7.625 14.487a2.946 2.946 0 00.595 3.9 10.7 10.7 0 006.862 2.2 3.121 3.121 0 003.035-2.31l3.179-11.635z"
          transform="translate(-955.435 -92.165)"
          fill="url(#prefix__R)"
        />
        <path
          data-name="Path 8810"
          d="M1302.94 198.13s14.184 25.924 39.806 5.045l2.92 4.626s-18.759 28.973-41.887 8.867z"
          transform="translate(-1004.257 -147.775)"
          fill="url(#prefix__S)"
        />
        <path
          data-name="Path 8811"
          d="M1476.588 199.11a3.6 3.6 0 00-2.107-2.3l-9.912-3.988s-.15-1.271 2.094-2.135a2.979 2.979 0 001.718-3.375s-3.065 1.4-7.551 3.617a10.508 10.508 0 00-4.77 5.192l2.542 3.355a45.351 45.351 0 0018.523 1.459z"
          transform="translate(-1118.461 -139.705)"
          fill="url(#prefix__T)"
        />
        <path
          data-name="Path 8812"
          d="M1095.231 194.52s-24.071 12.454-21.413 35.981 39.119 1.929 39.119 1.929l-.884-5.66s-22.307 6.473-26.02.9c-2.724-4.082 6.41-13.648 11.473-18.459a5.98 5.98 0 001.324-6.834z"
          transform="translate(-833.215 -145.082)"
          fill="url(#prefix__U)"
        />
        <path
          data-name="Path 8813"
          d="M276.435 95.307l10.095-35.251a1.017 1.017 0 01.869-.74c1.827-.214 7.116-.813 13.247-1.329 7.37-.625 15.928-1.128 21.041-.7a1.029 1.029 0 01.844 1.484c-2.907 5.884-14.87 29.817-20.861 37.658a1.04 1.04 0 01-.834.409l-23.418-.219a1.032 1.032 0 01-.984-1.314z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8814"
          d="M301.697 54.94l7.317-1.22a.526.526 0 01.584.684l-.735 2.2a.523.523 0 01-.427.356l-7.043.94a.526.526 0 01-.582-.64l.45-1.916a.529.529 0 01.436-.404z"
          fill="#7d97f4"
        />
        <path
          data-name="Path 8815"
          d="M296.215 61.132l.6-3.141a.727.727 0 01.641-.585l14.779-1.5a.727.727 0 01.78.892l-.94 3.911a.722.722 0 01-.668.557l-14.444.727a.727.727 0 01-.75-.862z"
          fill="#7d97f4"
        />
        <path
          data-name="Path 8816"
          d="M1222.143 306.261s-1.405-5.782-.839-7.833 1.665-4.689 5.337-4.1a53.433 53.433 0 017.983 2.127 2.1 2.1 0 01-3 1.81l1.726 1.337s-.254 2.14-2.6 1l1.6 1.779a1.875 1.875 0 01-2.74.63c-1.718-1.132-2.556 3.946-7.467 3.25z"
          transform="translate(-943.269 -219.46)"
          fill="url(#prefix__V)"
        />
        <path
          data-name="Path 8817"
          d="M1285.253 82.663s2.232 5.157-.391 12.995-6.908 8.519-9.622 6.583-6.232-5.4-6.669-12.5 13.607-13.597 16.682-7.078z"
          transform="translate(-978.615 -59.647)"
          fill="url(#prefix__W)"
        />
        <path
          data-name="Path 8818"
          d="M1260.2 66.089s4.737-10.608 11.841-4l.546 2.732s6.766-1.926 4.542-8.057a12.439 12.439 0 00-17.547-6.326c-7.241 3.962-9.693 8.654-9.3 14.233s4.575 3.67 4.575 3.67.806-4.1 2.77-4.829 1.924 2.376 1.924 2.376z"
          transform="translate(-964.948 -36.46)"
          fill="url(#prefix__X)"
        />
        <path
          data-name="Path 8819"
          d="M1273.541 100.539s2.465-5.439-.989-5.635-2.051 5.243-1.362 7.228z"
          transform="translate(-979.926 -70.781)"
          fill="url(#prefix__Y)"
        />
        <path
          data-name="Path 8820"
          d="M1133.046 41a2.428 2.428 0 001.4-4.066c-4.249-4.643-12.27-9.8-23.7-1.888-12.873 8.9-19.824 12.934-23 12.088a2.439 2.439 0 00-2.9 3.413c.724 1.413 2.2 2.89 4.928 4.237 21.041 10.379 31.919-12.39 43.272-13.784z"
          transform="translate(-841.386 -23.078)"
          fill="url(#prefix__Z)"
        />
        <path
          data-name="Path 8821"
          d="M1580.306 299.98l-4.005-4.788a5.159 5.159 0 01-1.016-4.664 55.134 55.134 0 001.863-12.433 5.165 5.165 0 012.333-4.171l5.243-3.4a6.173 6.173 0 002.628-6.666l-1.9-7.625a6.171 6.171 0 00-5.446-4.659l-6.224-.552a5.167 5.167 0 01-4.013-2.595 55.208 55.208 0 00-7.467-10.113 5.167 5.167 0 01-1.3-4.6l1.3-6.1a6.171 6.171 0 00-2.854-6.575l-6.738-4.066a6.178 6.178 0 00-7.147.557l-4.786 4.008a5.167 5.167 0 01-4.666 1.017 55.13 55.13 0 00-12.433-1.863 5.164 5.164 0 01-4.161-2.348l-3.4-5.243a6.173 6.173 0 00-6.666-2.636l-7.625 1.9a6.176 6.176 0 00-4.661 5.447l-.552 6.224a5.174 5.174 0 01-2.592 4.016 54.991 54.991 0 00-10.115 7.467 5.164 5.164 0 01-4.595 1.294l-6.1-1.3a6.173 6.173 0 00-6.575 2.854l-4.054 6.738a6.173 6.173 0 00.554 7.144l4.008 4.788a5.16 5.16 0 011.017 4.664 55.121 55.121 0 00-1.863 12.436 5.169 5.169 0 01-2.333 4.171l-5.243 3.4a6.181 6.181 0 00-2.63 6.669l1.9 7.625a6.173 6.173 0 005.444 4.661l6.224.551a5.156 5.156 0 014.016 2.592 55.312 55.312 0 007.467 10.115 5.159 5.159 0 011.3 4.592l-1.3 6.1a6.176 6.176 0 002.854 6.575l6.738 4.066a6.178 6.178 0 007.147-.557l4.786-4.005a5.167 5.167 0 014.666-1.017 54.967 54.967 0 0012.433 1.863 5.167 5.167 0 014.171 2.336l3.4 5.241a6.179 6.179 0 006.669 2.631l7.624-1.9a6.175 6.175 0 004.661-5.447l.552-6.224a5.166 5.166 0 012.592-4.016 54.994 54.994 0 0010.115-7.467 5.162 5.162 0 014.592-1.294l6.1 1.3a6.173 6.173 0 006.575-2.854l4.066-6.735a6.173 6.173 0 00-.578-7.129zm-78.114 17.52a45.748 45.748 0 1160.908-21.857 45.748 45.748 0 01-60.908 21.857z"
          transform="translate(-1118.353 -156.841)"
          fill="url(#prefix__aa)"
        />
        <path
          data-name="Path 8822"
          d="M414.145 185.949a7.03 7.03 0 01-5.891-3.2l-3.4-5.243a4.334 4.334 0 00-3.49-1.949 55.974 55.974 0 01-12.626-1.891 4.32 4.32 0 00-3.9.839l-4.786 4.008a7.022 7.022 0 01-8.133.63l-6.735-4.066a7.022 7.022 0 01-3.248-7.477l1.3-6.1a4.321 4.321 0 00-1.085-3.84 56.06 56.06 0 01-7.579-10.253 4.321 4.321 0 00-3.355-2.17l-6.224-.554a7.027 7.027 0 01-6.194-5.3l-1.9-7.625a7.022 7.022 0 012.991-7.581l5.241-3.4a4.321 4.321 0 001.949-3.49 56.121 56.121 0 011.891-12.624 4.321 4.321 0 00-.836-3.9l-4.008-4.788a7.024 7.024 0 01-.633-8.133l4.066-6.738a7.022 7.022 0 017.474-3.246l6.1 1.3a4.321 4.321 0 003.84-1.088 56.113 56.113 0 0110.27-7.581 4.321 4.321 0 002.171-3.357l.552-6.224a7.022 7.022 0 015.3-6.191l7.625-1.9a7.025 7.025 0 017.581 2.991l3.408 5.233a4.32 4.32 0 003.49 1.949 56.021 56.021 0 0112.626 1.891 4.321 4.321 0 003.9-.839l4.786-4.008a7.033 7.033 0 018.133-.63l6.735 4.066a7.019 7.019 0 013.248 7.475l-1.3 6.1a4.321 4.321 0 001.085 3.84 56.244 56.244 0 017.584 10.27 4.321 4.321 0 003.355 2.173l6.224.552a7.027 7.027 0 016.194 5.3l1.9 7.625a7.02 7.02 0 01-2.991 7.579l-5.238 3.406a4.321 4.321 0 00-1.947 3.49 56.025 56.025 0 01-1.893 12.626 4.321 4.321 0 00.839 3.9l4.008 4.786a7.02 7.02 0 01.63 8.133l-4.066 6.738a7.022 7.022 0 01-7.482 3.238l-6.1-1.3a4.32 4.32 0 00-3.84 1.085 55.968 55.968 0 01-10.271 7.581 4.321 4.321 0 00-2.17 3.357l-.552 6.224a7.022 7.022 0 01-5.3 6.191l-7.625 1.9a7.119 7.119 0 01-1.7.206zm-26.554-14.126a6.046 6.046 0 011.586.211 54.523 54.523 0 0012.245 1.835 6.013 6.013 0 014.849 2.717l3.4 5.243a5.337 5.337 0 005.754 2.27l7.625-1.9a5.337 5.337 0 004.021-4.7l.552-6.224a6.031 6.031 0 013.014-4.676 54.439 54.439 0 009.96-7.35 6.013 6.013 0 015.337-1.5l6.1 1.3a5.337 5.337 0 005.673-2.465l4.066-6.735a5.337 5.337 0 00-.48-6.166l-4.002-4.785a6.023 6.023 0 01-1.174-5.429 54.359 54.359 0 001.835-12.243 6.029 6.029 0 012.72-4.852l5.261-3.4a5.337 5.337 0 002.27-5.754l-1.9-7.625a5.337 5.337 0 00-4.712-4.031l-6.224-.552a6.023 6.023 0 01-4.674-3.007 54.338 54.338 0 00-7.353-9.96 6.023 6.023 0 01-1.5-5.337l1.3-6.1a5.337 5.337 0 00-2.463-5.673l-6.738-4.054a5.337 5.337 0 00-6.166.478l-4.793 3.988a6.013 6.013 0 01-5.431 1.174 54.368 54.368 0 00-12.242-1.832 6.024 6.024 0 01-4.849-2.719l-3.4-5.243a5.337 5.337 0 00-5.754-2.27l-7.625 1.9a5.337 5.337 0 00-4.021 4.7l-.552 6.224a6.023 6.023 0 01-3.014 4.674 54.388 54.388 0 00-9.96 7.348 6.013 6.013 0 01-5.337 1.5l-6.1-1.3a5.337 5.337 0 00-5.673 2.465l-4.066 6.735a5.337 5.337 0 00.48 6.166l4.005 4.786a6.019 6.019 0 011.177 5.429 54.225 54.225 0 00-1.835 12.243 6.024 6.024 0 01-2.72 4.852l-5.24 3.4a5.337 5.337 0 00-2.27 5.754l1.9 7.625a5.337 5.337 0 004.7 4.021l6.224.551a6.026 6.026 0 014.674 3.014 54.321 54.321 0 007.353 9.958 6.016 6.016 0 011.5 5.337l-1.3 6.1a5.337 5.337 0 002.463 5.673l6.738 4.054a5.337 5.337 0 006.166-.478l4.786-4.008a5.99 5.99 0 013.834-1.357zm15.7-5.945a46.345 46.345 0 01-19.827-4.454 46.625 46.625 0 1119.824 4.453zm-19.092-5.985a33.74 33.74 0 10-.005 0z"
        />
        <path
          data-name="Path 8823"
          d="M1599.964 410.771s19.633-4.923 40.375-1.954a20.167 20.167 0 0114.156 9.216c5.675 8.979 13.7 24.983 12 41.681l-8.9 2.2s-6.156-19.806-13.084-27.865c0 0-8.2 18.7-7.79 28.974.013.29.03.574.056.849.943 10.049-39.394 1.876-39.394 1.876z"
          transform="translate(-1223.872 -304.205)"
          fill="url(#prefix__ab)"
        />
        <path
          data-name="Path 8824"
          d="M1669.85 331.387l.9 13.925a3.024 3.024 0 002.1 2.742c2.707.8 7.82 1.779 12.832-.254a2 2 0 001.08-2.447l-6.628-21.293z"
          transform="translate(-1277.916 -241.699)"
          fill="url(#prefix__ac)"
        />
        <path
          data-name="Path 8825"
          d="M1646.96 273.54s-4.234 9.729-4.519 14.835-1.375 8.41 4.519 9.447 10.878-1.914 13.572-7c0 0 4.222-7.836 3.274-11.046s-16.846-6.236-16.846-6.236z"
          transform="translate(-1257.275 -204.019)"
          fill="url(#prefix__ad)"
        />
        <path
          data-name="Path 8826"
          d="M1656.482 256h-.747s3.075-6.306.374-7.414-13.4-3.3-15.714-7.088a7.051 7.051 0 012.73-9.714.4.4 0 01.508.186l.254.465a.4.4 0 00.74-.076.4.4 0 01.719-.109c.707 1.136 2.62 2.984 7.754 3.929 7.284 1.344 12.1 4.293 12.217 9.327a.4.4 0 00.623.328c.536-.325 1.4-.48 2.542.488 2 1.68 1.182 6.044-3.2 9.632a.4.4 0 00.02.643c.793.508 1.98 1.749-1.093 3.39-3.139 1.677-5 1.494-5.7 1.317a.4.4 0 01-.3-.417l.274-4.46a.4.4 0 00-.4-.427z"
          transform="translate(-1255.233 -172.849)"
          fill="url(#prefix__ae)"
        />
        <path
          data-name="Path 8827"
          d="M1705.78 316.8s1.614-6.214 4.4-4.473-1.446 6.964-3.688 7.2z"
          transform="translate(-1304.714 -232.719)"
          fill="url(#prefix__af)"
        />
        <path
          data-name="Path 8828"
          d="M1558.647 459.31c-.869-6.14 5.49-15.168 8.133-18.594a5.679 5.679 0 001.184-3.411c.076-8.7-3.573-14.283-9.424-18.045 0 0-21.237 24.742-15.829 43.77a16 16 0 002.633 5.337c.85-7.161 9.128-8.727 13.303-9.057z"
          transform="translate(-1182.433 -312.704)"
          fill="url(#prefix__ag)"
        />
        <path
          data-name="Path 8829"
          d="M1607.188 519.174l-.808-.092c.686-6.021 5.97-13.455 8.209-16.372l.646.508c-2.199 2.849-7.383 10.139-8.047 15.956z"
          transform="translate(-1230.577 -374.945)"
          fill="url(#prefix__ah)"
        />
        <path
          data-name="Path 8830"
          d="M1569.093 577.691a7.791 7.791 0 01-.168-.851c-4.176.33-12.453 1.9-13.315 9.066 9.478 12.532 35.6 8 35.6 8v-4.87s-20.064-3.723-22.117-11.345z"
          transform="translate(-1192.71 -430.234)"
          fill="url(#prefix__ai)"
        />
        <path
          data-name="Path 8831"
          d="M1685.79 619.468s3.858-9.1 10.654-5.871 6.26 5.337 6.26 5.337z"
          transform="translate(-1289.805 -457.133)"
          fill="url(#prefix__aj)"
        />
        <path
          data-name="Path 8832"
          d="M1682.369 626.875a1.294 1.294 0 001.332 1.189l35.216-1.23a1.291 1.291 0 001.187-.9l1.016-3.271a1.291 1.291 0 00-1.164-1.675l-12.84-.681a1.333 1.333 0 00-.348.028l-23.395 5.182a1.294 1.294 0 00-1.004 1.358z"
          transform="translate(-1287.25 -462.651)"
          fill="url(#prefix__ak)"
        />
        <path
          data-name="Path 8833"
          d="M1775.26 627.856l.971-4.516 13.191.63-.869 3.746z"
          transform="translate(-1356.535 -464.916)"
          fill="url(#prefix__al)"
        />
        <path
          data-name="Path 8834"
          d="M1733.743 435.283c-.745 6.1-4.1 30.885-5.065 37.968a1.627 1.627 0 001.66 1.843l56.974-1.632a1.629 1.629 0 001.542-1.271l8.862-39.9a1.627 1.627 0 00-1.685-1.977l-60.766 3.558a1.629 1.629 0 00-1.522 1.411z"
          transform="translate(-1321.781 -320.944)"
          fill="url(#prefix__am)"
        />
        <path
          data-name="Path 8835"
          d="M1814.05 542.873l-8.42 23.89 19.57.414 1.632-24.17a1.878 1.878 0 00-2-2l-9.149.607a1.875 1.875 0 00-1.633 1.259z"
          transform="translate(-1379.187 -403.506)"
          fill="url(#prefix__an)"
        />
        <path
          data-name="Path 8836"
          d="M1774.25 637.83a1.017 1.017 0 00.966 1.334h30.661a1.017 1.017 0 001.016-1.017v-1.314a1.016 1.016 0 00-1.06-1.017l-30.669 1.317a1.017 1.017 0 00-.914.697z"
          transform="translate(-1355.745 -474.222)"
          fill="url(#prefix__ao)"
        />
        <path
          data-name="Path 8837"
          d="M411.179 139.563l-.559-.071 2.8-22.076a2.958 2.958 0 012.752-2.575l52.51-3.172.033.564-52.51 3.172a2.387 2.387 0 00-2.224 2.081z"
          fill="#bdd0fb"
        />
        <path
          data-name="Rectangle 1177"
          fill="#bdd0fb"
          d="M409.213 150.554l.602-4.777.56.07-.603 4.778z"
        />
        <path
          data-name="Path 8842"
          d="M383.603 265.226l-.856.742a.3.3 0 11-.391-.452l.872-.712a.282.282 0 11.363.432z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8843"
          d="M378.355 269.54l-.9.689a.4.4 0 11-.485-.63l.912-.661a.381.381 0 01.455.61z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8844"
          d="M372.883 273.565l-.93.648a.508.508 0 11-.567-.816l.943-.615a.481.481 0 01.536.8z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8845"
          d="M367.236 277.348l-.953.607a.601.601 0 01-.641-1.017l.966-.577a.58.58 0 01.6.986z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8846"
          d="M361.441 280.893l-.981.567a.664.664 0 11-.666-1.149l.981-.549a.656.656 0 01.648 1.138z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8847"
          d="M355.521 284.23l-1 .539a.722.722 0 01-.684-1.271l1-.508a.712.712 0 01.666 1.256z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8848"
          d="M349.514 287.394l-1.017.508a.776.776 0 11-.7-1.383l1.016-.493a.767.767 0 11.684 1.373z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8849"
          d="M343.43 290.408l-1.017.491a.831.831 0 01-.717-1.5l1.017-.47a.822.822 0 01.7 1.487z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8850"
          d="M337.24 293.247l-1.05.44a.862.862 0 11-.666-1.591l1.037-.427a.86.86 0 01.661 1.586z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8851"
          d="M330.897 295.736l-1.068.386a.869.869 0 11-.59-1.634l1.055-.379a.868.868 0 11.589 1.632z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8852"
          d="M324.459 297.952l-1.08.346a.877.877 0 11-.531-1.67l1.073-.338a.875.875 0 11.528 1.667z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8853"
          d="M317.955 299.932l-1.09.313a.884.884 0 01-.483-1.7l1.083-.307a.88.88 0 01.483 1.693z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8854"
          d="M311.405 301.723l-1.1.28a.888.888 0 01-.44-1.721l1.09-.28a.888.888 0 11.44 1.721z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8855"
          d="M304.797 303.345l-1.1.254a.9.9 0 11-.406-1.743l1.1-.254a.893.893 0 01.4 1.741z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8856"
          d="M298.172 304.821l-1.108.234a.901.901 0 01-.371-1.764l1.1-.229a.9.9 0 11.369 1.761z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8857"
          d="M291.515 306.163l-1.113.211a.907.907 0 01-.338-1.779l1.105-.208a.907.907 0 11.341 1.779z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8858"
          d="M284.836 307.381l-1.116.19a.915.915 0 01-.31-1.8l1.111-.188a.913.913 0 01.31 1.8z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8859"
          d="M278.084 308.491l-1.118.173a.921.921 0 01-.282-1.82l1.113-.168a.92.92 0 01.282 1.817z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8860"
          d="M271.249 309.497l-1.121.153a.926.926 0 01-.254-1.835l1.116-.15a.926.926 0 01.254 1.835z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8861"
          d="M264.522 310.38l-1.123.137a.933.933 0 01-.224-1.853l1.118-.132a.933.933 0 11.226 1.85z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8862"
          d="M257.779 311.158l-1.123.122a.941.941 0 01-.2-1.871l1.121-.117a.938.938 0 11.2 1.865z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8863"
          d="M251.029 311.846l-1.126.1a.946.946 0 11-.173-1.883l1.123-.1a.946.946 0 11.173 1.881z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8864"
          d="M244.262 312.416l-1.126.089a.953.953 0 11-.147-1.9l1.123-.084a.953.953 0 11.145 1.9z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8865"
          d="M237.493 312.896l-1.128.071a.959.959 0 01-.119-1.914l1.123-.066a.958.958 0 11.12 1.911z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8866"
          d="M230.716 313.277l-1.131.053a.966.966 0 11-.092-1.929l1.126-.051a.965.965 0 11.092 1.927z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8867"
          d="M223.934 313.554l-1.129.035a.969.969 0 11-.061-1.936l1.126-.036a.97.97 0 11.069 1.937z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8868"
          d="M217.15 313.722l-1.131.016a.963.963 0 11-.031-1.924l1.126-.018a.963.963 0 11.038 1.924z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8869"
          d="M210.361 313.783h-1.121a.956.956 0 010-1.911h1.126a.958.958 0 110 1.914z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8870"
          d="M203.573 313.736l-1.131-.018a.951.951 0 01.031-1.9l1.126.018a.951.951 0 01-.023 1.9z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8871"
          d="M196.782 313.577l-1.131-.038a.944.944 0 11.064-1.886l1.126.036a.945.945 0 11-.053 1.888z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8872"
          d="M190.002 313.302l-1.131-.056a.938.938 0 11.1-1.873l1.123.056a.938.938 0 11-.084 1.873z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8873"
          d="M183.223 312.909l-1.131-.079a.931.931 0 01.13-1.858l1.123.076a.933.933 0 01-.127 1.86z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8874"
          d="M176.45 312.385l-1.126-.1a.925.925 0 11.163-1.843l1.121.1a.926.926 0 01-.16 1.845z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8875"
          d="M169.689 311.723l-1.123-.122a.92.92 0 01.2-1.827l1.118.119a.92.92 0 11-.2 1.827z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8876"
          d="M162.944 310.926l-1.123-.147a.913.913 0 11.239-1.809l1.116.145a.913.913 0 01-.234 1.81z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8877"
          d="M156.217 309.971l-1.118-.175a.9.9 0 11.279-1.779l1.111.173a.907.907 0 11-.277 1.779z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8878"
          d="M149.509 308.849l-1.113-.2a.904.904 0 11.323-1.779l1.108.2a.904.904 0 11-.32 1.779z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8879"
          d="M142.841 307.548l-1.108-.236a.893.893 0 01.371-1.746l1.1.231a.895.895 0 11-.369 1.751z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8880"
          d="M136.207 306.051l-1.1-.269a.887.887 0 01.424-1.723l1.093.267a.888.888 0 11-.419 1.726z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8881"
          d="M129.622 304.338l-1.093-.308a.883.883 0 01.478-1.7l1.083.3a.883.883 0 01-.475 1.7z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8882"
          d="M123.101 302.389l-1.08-.348a.875.875 0 01.539-1.665l1.068.346a.877.877 0 01-.536 1.667z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8883"
          d="M116.66 300.176l-1.065-.4a.869.869 0 11.607-1.627l1.052.389a.87.87 0 01-.6 1.632z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8884"
          d="M110.321 297.669l-1.042-.45a.862.862 0 11.681-1.581l1.029.442a.862.862 0 01-.676 1.586z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8885"
          d="M104.125 294.818l-1.017-.508a.844.844 0 11.762-1.507l1.017.508a.85.85 0 01-.747 1.525z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8886"
          d="M98.107 291.606l-.984-.574a.823.823 0 01.826-1.423l.968.559a.826.826 0 01-.826 1.431z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8887"
          d="M92.325 287.977l-.938-.648a.803.803 0 11.91-1.324l.923.63a.808.808 0 11-.912 1.332z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8888"
          d="M86.833 283.889l-.879-.729a.785.785 0 011-1.21l.864.709a.788.788 0 11-1 1.217z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8889"
          d="M81.745 279.315l-.8-.816a.766.766 0 111.088-1.078l.785.79a.769.769 0 11-1.09 1.085z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8890"
          d="M77.167 274.201l-.7-.9a.748.748 0 011.177-.925l.691.874a.763.763 0 01-1.179.93z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8891"
          d="M73.233 268.582l-.585-.983a.727.727 0 111.248-.747l.574.953v.015a.733.733 0 01-1.253.762z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8892"
          d="M70.059 262.494l-.447-1.055a.709.709 0 011.3-.557v.015l.442 1.017a.712.712 0 01-1.306.564z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8893"
          d="M67.739 256.034l-.3-1.1a.691.691 0 011.332-.366v.015l.3 1.073v.015a.692.692 0 01-1.334.371z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8894"
          d="M66.307 249.324l-.153-1.131a.671.671 0 011.329-.186v.015l.155 1.1v.015a.676.676 0 01-1.337.188z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8895"
          d="M65.736 242.503l-.018-1.141a.653.653 0 011.3-.023l.023 1.116v.013a.656.656 0 11-1.309.025z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8896"
          d="M65.944 235.667l.107-1.133a.638.638 0 011.271.112l-.1 1.116a.638.638 0 11-1.271-.109z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8897"
          d="M66.846 228.899l.211-1.118a.606.606 0 111.192.219l-.2 1.1a.61.61 0 11-1.2-.214z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8898"
          d="M68.338 222.244l.3-1.1a.572.572 0 011.1.295l-.29 1.09a.577.577 0 01-1.116-.292z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8899"
          d="M70.32 215.732l.374-1.073a.537.537 0 011.017.348l-.356 1.065a.544.544 0 11-1.032-.346z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8900"
          d="M72.714 209.358l.435-1.047a.508.508 0 01.933.381l-.419 1.045a.51.51 0 11-.945-.381z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8901"
          d="M75.454 203.137l.485-1.017a.47.47 0 11.851.4l-.473 1.017a.476.476 0 01-.864-.4z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8902"
          d="M78.484 197.06l.531-1a.438.438 0 01.775.407l-.508 1a.442.442 0 11-.785-.407z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8903"
          d="M81.768 191.123l.567-.979a.403.403 0 01.7.4l-.557.979a.41.41 0 11-.714-.4z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8904"
          d="M85.262 185.298l.6-.956a.371.371 0 01.628.391l-.59.958a.375.375 0 11-.64-.389z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8905"
          d="M88.942 179.6l.63-.938a.336.336 0 01.559.374l-.62.94a.341.341 0 11-.572-.371z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8906"
          d="M92.788 174.014l.653-.923a.303.303 0 01.493.351l-.643.925a.309.309 0 01-.508-.351z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8907"
          d="M108.953 125.497l3.08 7 3.418-5.1z"
          fill="#7d97f4"
        />
        <path
          data-name="Path 8908"
          d="M138.689 107.623l-11.612 24.91a1.937 1.937 0 01-2.641.9l-24.571-12.6a.778.778 0 01.13-1.433z"
          fill="#91b3fa"
        />
        <path
          data-name="Path 8909"
          d="M108.955 125.498l29.723-17.875-25.763 19.921.773 1.98z"
          fill="#7d97f4"
        />
        <path
          data-name="Path 8910"
          d="M115.271 128.74l-3.238 3.761.88-4.958z"
          fill="#7d97f4"
        />
        <path
          data-name="Path 8911"
          d="M149.121 257.571l-1.083-3.192a.488.488 0 11.923-.313l1.083 3.22a.483.483 0 11-.915.307z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8912"
          d="M145.725 248.016l-1.159-3.185a.508.508 0 11.945-.343l1.146 3.182a.508.508 0 11-.935.341z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8913"
          d="M142.36 238.413l-1.017-3.238a.519.519 0 11.989-.312l1.017 3.223a.513.513 0 11-.978.308z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8914"
          d="M139.499 228.628l-.8-3.3a.534.534 0 011.037-.254l.778 3.284v.013a.529.529 0 01-1.017.254z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8915"
          d="M137.379 218.654l-.508-3.363a.55.55 0 011.085-.17v.015l.508 3.335v.015a.545.545 0 01-1.078.165z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8916"
          d="M136.105 208.528l-.231-3.4a.567.567 0 011.128-.076v.015l.219 3.362v.018a.56.56 0 11-1.116.074z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8917"
          d="M135.702 198.331l.053-3.4a.582.582 0 111.161.018v.015l-.066 3.37v.015a.575.575 0 01-1.149-.02z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8918"
          d="M136.139 188.137l.323-3.385a.6.6 0 111.187.112v.015l-.338 3.357v.015a.592.592 0 01-1.177-.114z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8919"
          d="M137.358 178.009l.569-3.352a.611.611 0 111.2.2v.013l-.572 3.324v.013a.608.608 0 01-1.2-.2z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8920"
          d="M139.287 167.995l.78-3.284a.628.628 0 111.22.29l-.785 3.258a.623.623 0 01-1.21-.29z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8921"
          d="M141.885 158.15l1.042-3.24a.643.643 0 111.223.391v.015l-1.04 3.206v.015a.638.638 0 01-1.212-.391z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8922"
          d="M145.272 148.514l1.3-3.146a.658.658 0 111.215.508v.015l-1.294 3.111v.018a.654.654 0 01-1.2-.508z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8923"
          d="M149.404 139.182l1.543-3.035a.673.673 0 111.2.61v.015l-1.525 3v.015a.668.668 0 01-1.189-.607z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8924"
          d="M154.273 130.205l1.779-2.9a.686.686 0 111.172.714v.015l-1.764 2.869v.015a.682.682 0 11-1.164-.712z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8925"
          d="M159.81 121.628l1.988-2.765a.703.703 0 111.141.821v.013l-1.993 2.732v.015a.7.7 0 01-1.131-.816z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8926"
          d="M165.977 113.489l2.186-2.608a.707.707 0 111.085.907l-2.165 2.582v.013a.707.707 0 01-1.083-.907z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8927"
          d="M172.716 105.822l2.361-2.448a.709.709 0 011.017.984l-2.343 2.425v.013a.709.709 0 01-1.017-.986z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8928"
          d="M179.968 98.64l2.524-2.287a.713.713 0 01.956 1.057l-2.5 2.262a.713.713 0 01-.956-1.057z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8929"
          d="M187.681 91.958l2.666-2.115a.717.717 0 11.89 1.123l-2.641 2.094a.717.717 0 11-.89-1.121z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8930"
          d="M195.808 85.787l2.8-1.939a.72.72 0 01.821 1.182l-2.77 1.924a.72.72 0 11-.821-1.182z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8931"
          d="M204.305 80.137l2.9-1.766a.727.727 0 11.762 1.238l-2.882 1.749h-.013a.723.723 0 01-.75-1.235z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8932"
          d="M213.129 75.015l3.011-1.588a.727.727 0 11.679 1.286h-.013l-2.991 1.578a.724.724 0 11-.676-1.271z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8933"
          d="M222.243 70.428l3.1-1.406a.73.73 0 01.6 1.329h-.015l-3.07 1.393h-.013a.73.73 0 01-.6-1.329z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8934"
          d="M231.601 66.395l3.174-1.22a.733.733 0 11.529 1.367l-3.149 1.21h-.013a.732.732 0 11-.526-1.367z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8935"
          d="M241.205 62.92l3.24-1.017a.737.737 0 01.447 1.405h-.015l-3.215 1.017a.737.737 0 11-.445-1.4z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8936"
          d="M250.99 60.028l3.3-.831a.74.74 0 11.361 1.436h-.016l-3.271.821a.74.74 0 11-.361-1.433z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8937"
          d="M260.936 57.738l3.345-.623a.743.743 0 11.272 1.461h-.015l-3.3.618h-.018a.743.743 0 11-.27-1.461z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8938"
          d="M270.996 56.083l3.38-.4a.747.747 0 01.178 1.484l-3.347.4h-.015a.747.747 0 01-.178-1.482z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8939"
          d="M281.162 55.1l3.4-.17a.762.762 0 01.074 1.5h-.018l-3.365.168h-.018a.75.75 0 01-.074-1.5z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8940"
          d="M291.379 54.836l3.406.079a.762.762 0 01-.036 1.507h-.021l-3.367-.081h-.018a.762.762 0 01.036-1.5z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8941"
          d="M301.583 55.342c1.131.109 2.262.219 3.388.348a.762.762 0 11-.173 1.494c-1.118-.13-2.234-.239-3.35-.348a.762.762 0 11.145-1.5z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8942"
          d="M311.714 56.62l3.355.579a.762.762 0 11-.254 1.5h-.018l-3.319-.574h-.018a.762.762 0 11.254-1.494z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8943"
          d="M321.734 58.592l3.3.816a.763.763 0 01-.364 1.482h-.021l-3.268-.811h-.018a.763.763 0 01.366-1.482z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8944"
          d="M331.588 61.276l3.238 1.052a.767.767 0 01-.473 1.459h-.018l-3.2-1.045h-.016a.766.766 0 11.473-1.456z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8945"
          d="M341.223 64.669l3.151 1.286a.77.77 0 11-.582 1.426h-.018l-3.116-1.271h-.018a.769.769 0 11.582-1.423z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8946"
          d="M350.583 68.753l3.05 1.51a.774.774 0 11-.686 1.388h-.015l-3.017-1.5h-.018a.773.773 0 01.686-1.385z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8947"
          d="M359.629 73.49l2.94 1.716a.778.778 0 01-.783 1.342h-.015l-2.91-1.7h-.015a.776.776 0 11.783-1.339z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8948"
          d="M368.336 78.833l2.821 1.9a.781.781 0 11-.874 1.294h-.013l-2.8-1.886a.779.779 0 11.872-1.291z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8949"
          d="M376.672 84.715l2.7 2.066a.785.785 0 01-.953 1.245l-2.676-2.051a.781.781 0 11.95-1.24z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8950"
          d="M384.658 91.063l2.585 2.211a.788.788 0 11-1.017 1.195l-2.58-2.211a.785.785 0 111.017-1.195z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8951"
          d="M392.3 97.816l2.468 2.32a.79.79 0 01-1.083 1.151l-2.458-2.313a.79.79 0 111.083-1.149z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8952"
          d="M399.627 104.899l2.379 2.425a.8.8 0 01-1.134 1.113l-2.364-2.412a.793.793 0 111.131-1.111z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8953"
          d="M406.676 112.254l2.287 2.5a.8.8 0 01-1.174 1.078l-2.287-2.491a.8.8 0 011.172-1.075z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8954"
          d="M413.491 119.818l2.229 2.557a.8.8 0 11-1.2 1.052l-2.219-2.542a.8.8 0 011.2-1.05z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8955"
          d="M420.128 127.532l2.181 2.595a.803.803 0 01-1.23 1.034l-2.174-2.595a.802.802 0 111.227-1.032z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8956"
          d="M426.641 135.339l2.155 2.613a.807.807 0 01-1.243 1.029l-2.153-2.613a.806.806 0 011.243-1.017z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8957"
          d="M433.102 143.178l2.156 2.61a.811.811 0 11-1.248 1.034l-2.155-2.613a.808.808 0 011.248-1.017z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8958"
          d="M439.588 150.992l2.183 2.582a.814.814 0 11-1.243 1.05l-2.188-2.592a.812.812 0 011.24-1.047z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8959"
          d="M446.194 158.688l2.247 2.521a.818.818 0 01-1.22 1.088l-2.257-2.542a.816.816 0 111.217-1.085z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8960"
          d="M453.032 166.155l2.354 2.414a.82.82 0 11-1.174 1.144l-2.374-2.437a.82.82 0 011.174-1.144z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8961"
          d="M460.238 173.239l2.511 2.237.02.018a.824.824 0 11-1.1 1.227l-2.542-2.27a.822.822 0 111.093-1.228z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8962"
          d="M467.977 179.686l2.725 1.949.031.02a.827.827 0 11-.963 1.344l-2.783-1.992a.826.826 0 11.963-1.342z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8963"
          d="M476.397 185.132q1.467.8 2.979 1.5a.831.831 0 11-.7 1.5q-1.555-.729-3.067-1.548a.83.83 0 01.79-1.459z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8964"
          d="M485.59 189.037q1.591.488 3.21.859a.834.834 0 01-.369 1.624q-1.685-.384-3.332-.892a.834.834 0 01.49-1.591z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8965"
          d="M495.365 190.854q1.657.107 3.319.089a.836.836 0 11.023 1.672q-1.729.018-3.449-.094a.836.836 0 01.109-1.667z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8966"
          d="M505 189.699a20.337 20.337 0 002.918-1.423.84.84 0 11.854 1.446 21.781 21.781 0 01-3.164 1.54.839.839 0 11-.607-1.563z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8967"
          d="M513.006 184.197a27.438 27.438 0 002.117-2.511.846.846 0 111.352 1.017 29.059 29.059 0 01-2.252 2.661.841.841 0 11-1.217-1.161z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8968"
          d="M518.445 176.014a30.067 30.067 0 001.172-3.075.846.846 0 011.611.508 31.386 31.386 0 01-1.238 3.251.847.847 0 11-1.546-.689z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8969"
          d="M520.872 166.51c.066-1.093.066-2.2.028-3.3a.811.811 0 011.619-.061 40.42 40.42 0 010 3.464.821.821 0 11-1.639-.089z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8970"
          d="M520.287 156.558l-.509-3.319v-.024a.773.773 0 011.525-.254l.554 3.37a.785.785 0 01-1.548.254z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8971"
          d="M518.438 146.647l-.781-3.279v-.015a.7.7 0 011.35-.338l.856 3.3a.73.73 0 01-1.413.369v-.041z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8972"
          d="M515.852 136.861l-1.017-3.21v-.015a.589.589 0 011.118-.371l1.088 3.215a.625.625 0 11-1.182.4z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8973"
          d="M512.512 127.331q-.632-1.561-1.337-3.085a.43.43 0 01.762-.376c.508 1.017 1 2.033 1.459 3.08a.488.488 0 01-.89.4z"
          fill="#bdd0fb"
        />
        <path
          data-name="Path 8974"
          d="M507.948 103.773l-5.672 8.494-3.314-7.495z"
          fill="#7d97f4"
        />
        <path
          data-name="Path 8975"
          d="M473.002 73.381l9.5 35.447a2.588 2.588 0 003.261 1.8l35.231-10.883a1.037 1.037 0 00.163-1.914z"
          fill="#91b3fa"
        />
        <path
          data-name="Path 8976"
          d="M507.945 103.77l-34.943-30.389 29.263 32.163-1.474 2.425z"
          fill="#7d97f4"
        />
        <path
          data-name="Path 8977"
          d="M498.89 106.572l3.385 5.7-.01-6.722z"
          fill="#7d97f4"
        />
      </g>
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
    